import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOCALSTORAGE } from '../../Config';
import GameStatsButton from '../GameStatsButton.jsx';

const NbaTodaySchedule = () => {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  const actionBtnOne = (
    game_ID,
    gameTitle,
    gameTime,
    gameDay,
    homeLogo,
    awayLogo,
    homeTeam,
    awayTeam,
    homeTeamId,
    awayTeamId
  ) => {
    const gameDetails = {
      game_ID,
      gameTitle,
      gameTime,
      gameDay,
      homeLogo,
      awayLogo,
      homeTeam,
      awayTeam,
      homeTeamId,
      awayTeamId,
      sportType: "NBA",
    };
    localStorage.setItem(
      LOCALSTORAGE.SELECTEDGAME,
      JSON.stringify(gameDetails)
    );
    navigate("/betPage");
  };

  useEffect(() => {
    const fetchGames = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          "https://site.api.espn.com/apis/site/v2/sports/basketball/nba/scoreboard"
        );
        const data = await response.json();
        const todayGames = (data.events || []).map((event) => {
          const competition = event.competitions[0];
          const home = competition.competitors.find((c) => c.homeAway === "home");
          const away = competition.competitors.find((c) => c.homeAway === "away");
          return {
            game_ID: event.id,
            gameTitle: `${away.team.abbreviation} vs ${home.team.abbreviation}`,
            gameTime: competition.date,
            gameDay: new Date(competition.date).toLocaleDateString(),
            homeLogo: home.team.logo,
            awayLogo: away.team.logo,
            homeTeam: home.team.displayName,
            awayTeam: away.team.displayName,
            homeTeamId: home.team.id,
            awayTeamId: away.team.id,
            status: competition.status.type.name,
          };
        });
        setGames(todayGames);
      } catch (error) {
        setGames([]);
      }
      setLoading(false);
    };
    fetchGames();
  }, []);

  const liveGames = games.filter((g) => g.status === "STATUS_IN_PROGRESS");
  const todayGames = games.filter((g) => {
    const gameDate = new Date(g.gameTime);
    const now = new Date();
    return (
      gameDate.getFullYear() === now.getFullYear() &&
      gameDate.getMonth() === now.getMonth() &&
      gameDate.getDate() === now.getDate()
    );
  });

  return (
    <div className="text-white text-center">
      <h1>Live NBA Games</h1>
      <div className="row justify-content-center">
        {liveGames.length === 0 && <p>No live games right now.</p>}
        {liveGames.map((game) => {
          const isFinal = game.status === "STATUS_FINAL";
          return (
          <div key={game.game_ID} className="col-3 card m-1 seasonal-sport-card position-relative" style={{ width: "20rem", opacity: isFinal ? 0.5 : 1 }}>
            <span className="seasonal-sport-card__spider" aria-hidden="true">🕷️</span>
            <span className="seasonal-sport-card__lights" aria-hidden="true">
              {Array.from({ length: 16 }, (_, index) => <i key={index} />)}
            </span>
            <div className="card-body">
              <GameStatsButton gameId={game.game_ID} sport="NBA" title={game.gameTitle} />
              <h5 className="card-title">{game.gameTitle}</h5>
              <div className="row align-items-center">
                <div className="col">
                  <img src={game.awayLogo} alt={game.awayTeam} style={{ width: 60, height: 60 }} />
                  <div style={{ fontSize: 12 }}>{game.awayTeam}</div>
                </div>
                <div className="col">
                  <img src={game.homeLogo} alt={game.homeTeam} style={{ width: 60, height: 60 }} />
                  <div style={{ fontSize: 12 }}>{game.homeTeam}</div>
                </div>
              </div>
              <p>
                {game.gameDay} at {new Date(game.gameTime).toLocaleTimeString()}
              </p>
              <div className="row">
                <div className="col">
                  <button
                    onClick={() =>
                      actionBtnOne(
                        game.game_ID,
                        game.gameTitle,
                        game.gameTime,
                        game.gameDay,
                        game.homeLogo,
                        game.awayLogo,
                        game.homeTeam,
                        game.awayTeam,
                        game.homeTeamId,
                        game.awayTeamId
                      )
                    }
                    className="btn btn-primary w-100"
                    disabled={isFinal}
                    title={isFinal ? "This game has ended" : undefined}
                  >
                    {isFinal ? "Game Over" : "Bet Friends"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          );
        })}
      </div>
      <h1 className="mt-4">Today's Games</h1>
      <div className="row justify-content-center">
        {todayGames.length === 0 && <p>No games today.</p>}
        {todayGames.map((game) => {
          const isFinal = game.status === "STATUS_FINAL";
          return (
          <div key={game.game_ID} className="col-3 card m-1 seasonal-sport-card position-relative" style={{ width: "20rem", opacity: isFinal ? 0.5 : 1 }}>
            <span className="seasonal-sport-card__spider" aria-hidden="true">🕷️</span>
            <span className="seasonal-sport-card__lights" aria-hidden="true">
              {Array.from({ length: 16 }, (_, index) => <i key={index} />)}
            </span>
            <div className="card-body">
              <GameStatsButton gameId={game.game_ID} sport="NBA" title={game.gameTitle} />
              <h5 className="card-title">{game.gameTitle}</h5>
              <div className="row align-items-center">
                <div className="col">
                  <img src={game.awayLogo} alt={game.awayTeam} style={{ width: 60, height: 60 }} />
                  <div style={{ fontSize: 12 }}>{game.awayTeam}</div>
                </div>
                <div className="col">
                  <img src={game.homeLogo} alt={game.homeTeam} style={{ width: 60, height: 60 }} />
                  <div style={{ fontSize: 12 }}>{game.homeTeam}</div>
                </div>
              </div>
              <p>
                {game.gameDay} at {new Date(game.gameTime).toLocaleTimeString()}
              </p>
              <div className="row">
                <div className="col">
                  <button
                    onClick={() =>
                      actionBtnOne(
                        game.game_ID,
                        game.gameTitle,
                        game.gameTime,
                        game.gameDay,
                        game.homeLogo,
                        game.awayLogo,
                        game.homeTeam,
                        game.awayTeam,
                        game.homeTeamId,
                        game.awayTeamId
                      )
                    }
                    className="btn btn-primary w-100"
                    disabled={isFinal}
                    title={isFinal ? "This game has ended" : undefined}
                  >
                    {isFinal ? "Game Over" : "Bet Friends"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          );
        })}
      </div>
    </div>
  );
};

// Weekly schedule (simple version, mirrors NFL's weekly view)
const NbaWeeklySchedule = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGames = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          "https://site.api.espn.com/apis/site/v2/sports/basketball/nba/scoreboard"
        );
        const data = await response.json();
        const weekGames = (data.events || []).map((event) => {
          const competition = event.competitions[0];
          const home = competition.competitors.find((c) => c.homeAway === "home");
          const away = competition.competitors.find((c) => c.homeAway === "away");
          return {
            game_ID: event.id,
            gameTitle: `${away.team.abbreviation} vs ${home.team.abbreviation}`,
            gameTime: competition.date,
            gameDay: new Date(competition.date).toLocaleDateString(),
            homeLogo: home.team.logo,
            awayLogo: away.team.logo,
            homeTeam: home.team.displayName,
            awayTeam: away.team.displayName,
            status: competition.status.type.name,
          };
        });
        setGames(weekGames);
      } catch (error) {
        setGames([]);
      }
      setLoading(false);
    };
    fetchGames();
  }, []);

  return (
    <div className="text-white text-center mt-4">
      <h1>This Week's Games</h1>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="row justify-content-center">
          {games.length === 0 && <p>No games this week.</p>}
          {games.map((game) => (
            <div key={game.game_ID} className="col-3 card m-1 seasonal-sport-card" style={{ width: "20rem" }}>
              <span className="seasonal-sport-card__spider" aria-hidden="true">🕷️</span>
              <span className="seasonal-sport-card__lights" aria-hidden="true">
                {Array.from({ length: 16 }, (_, index) => <i key={index} />)}
              </span>
              <div className="card-body">
                <h5 className="card-title">{game.gameTitle}</h5>
                <div className="row align-items-center">
                  <div className="col">
                    <img src={game.awayLogo} alt={game.awayTeam} style={{ width: 60, height: 60 }} />
                    <div style={{ fontSize: 12 }}>{game.awayTeam}</div>
                  </div>
                  <div className="col">
                    <img src={game.homeLogo} alt={game.homeTeam} style={{ width: 60, height: 60 }} />
                    <div style={{ fontSize: 12 }}>{game.homeTeam}</div>
                  </div>
                </div>
                <p>
                  {game.gameDay} at {new Date(game.gameTime).toLocaleTimeString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { NbaTodaySchedule, NbaWeeklySchedule };
